import { Menu } from 'antd';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { topMenuItems } from 'utils/menuItems';

const Menus = () => {
  const navigate = useNavigate();
  const handleMenu = (ev) => {
    navigate(ev.key);
  };
  return (
    <MenuScrollContainer data-scrollable>
      <StyledMenu
        theme='dark'
        // defaultSelectedKeys={['1']}
        mode='inline'
        items={topMenuItems}
        onClick={handleMenu}
      />
    </MenuScrollContainer>
  );
};

const MenuScrollContainer = styled.div`
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
`;

const StyledMenu = styled(Menu)`
  border-inline-end: 0 !important;
`;

export default Menus;
